import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95679b24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = {
  class: "materialCategory"
};
const _hoisted_3 = {
  class: "materialCategory__header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "materialCategory__header__name bg-red"
}, "分类列表", -1));
const _hoisted_5 = {
  class: "materialCategory__header__search"
};
const _hoisted_6 = {
  class: "materialCategory__header__add"
};
const _hoisted_7 = {
  class: "materialCategory__body"
};
const _hoisted_8 = {
  class: "flex justify-between",
  style: {
    "width": "100%",
    "padding-right": "20px"
  }
};
const _hoisted_9 = {
  key: 0
};
import { ref, onMounted, watch } from 'vue';
import { addMaterialCategory, getMaterialCategoryTree, deleteMaterialCategory } from '@/api/material';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  __name: 'MaterialCategory',
  emits: 'changeCategory',
  setup(__props, {
    emit: __emit
  }) {
    const keyword = ref('');
    const treeRef = ref(null);
    const emits = __emit;
    watch(keyword, val => {
      treeRef.value.filter(val);
    });
    const handleNodeClick = data => {
      emits('changeCategory', data.id);
    };
    const treeData = ref([]);
    const defaultProps = ref({
      children: 'children',
      label: 'title'
    });
    const _getMaterialCategoryTree = async () => {
      const res = await getMaterialCategoryTree({
        title: keyword.value
      });
      treeData.value = [{
        id: '',
        title: '全部'
      }, ...res];
    };
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.title.includes(value);
    };
    const dialogModel = ref(false);
    const formEl = ref(null);
    const formData = ref({
      title: ''
    });
    const handleAddCategory = async () => {
      dialogModel.value = true;
    };
    const handleAddCategorySubmit = async () => {
      formEl.value.validate(async valid => {
        if (!valid) return;
        await addMaterialCategory(formData.value);
        formEl.value.resetFields();
        _getMaterialCategoryTree();
        ElMessage.success('添加成功');
        dialogModel.value = false;
      });
    };
    const closed = () => {
      formEl.value.resetFields();
    };
    const handleRemove = (node, data) => {
      ElMessageBox.confirm('确定删除该分类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteMaterialCategory(data.id);
        _getMaterialCategoryTree();
        ElMessage.success('删除成功');
      });
    };
    onMounted(() => {
      _getMaterialCategoryTree();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入",
          size: "small"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: handleAddCategory,
          type: "primary",
          size: "small"
        }, {
          default: _withCtx(() => [_createTextVNode("新增")]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          style: {
            "max-width": "600px"
          },
          data: treeData.value,
          props: defaultProps.value,
          "filter-node-method": filterNode,
          onNodeClick: handleNodeClick
        }, {
          default: _withCtx(({
            data,
            node
          }) => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, _toDisplayString(data.title), 1), data.title !== '全部' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
            type: "danger",
            link: "",
            onClick: $event => handleRemove(node, data)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["data", "props"])])])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogModel.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogModel.value = $event),
        title: "新增素材库分类",
        "close-on-click-modal": false,
        class: "dialog-class",
        onClose: closed
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => dialogModel.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddCategorySubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: formData.value,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            "label-width": "150",
            prop: "title",
            label: "分类名称",
            rules: [{
              required: true,
              message: '请输入',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.title = $event),
              placeholder: "请输入分类名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};